'use strict';

var _ = require('lodash'),
	util = require('../../util'),
	linchpin = require('int_googletagmanager/linchpin/error');


var $form, $continue, $requiredInputs, validator, customCallback, $emptyInputs, $addressFinder;

//The properties with repeating values are used for add new credit card form in Wallet page fields of which have irregular names.
var errorMessages = {
	phone: Resources.MISSING_PHONE,
	addressFind: Resources.MISSING_ADDRESSFIND,
	missingmessage: Resources.MISSING_ERROR,
	defaultmessage: Resources.MISSING_DEFAULT,
	isbusinessni: Resources.NOT_SELECTED_NI_OPTION,
	eorinumberni: Resources.INVALID_EORI_NUMBER
};

var customErrorMessagesFields = ['email', 'password', 'passwordconfirm', 'passwordconfirmnomatch', 'firstname', 'forename', 'lastname', 'surname', 'addressFind', 'address1', 'line1', 'city', 'postal', 'zip', 'code', 'phone', 'isbusinessni', 'eorinumberni'];

var customErrorMessagesNames = {
	'email': 'email',
	'password': 'password',
	'passwordconfirm': 'password confirm',
	'firstname': 'first name',
	'forename': 'first name',
	'lastname': 'last name',
	'surname': 'last name',
	'address1': 'address line 1',
	'line1': 'address line 1',
	'city': 'city',
	'postal': 'postal code',
	'zip': 'zip code',
	'code': 'postal code'
};

var hasEmptyRequired = function () {
	// filter out only the visible fields
	var requiredValues = $requiredInputs.filter(':visible').map(function () {
		return $(this).val();
	});
	var reqEmpty = _(requiredValues).includes('');
	return customCallback() || reqEmpty;
};

function validateForm () {
	var $NITrueRadioInput = $('input[type="radio"][name$="_isBusinessNI"][value="true"]');
	var isNIChecked = $NITrueRadioInput.is(':checked');
	// only validate form when all required fields are filled to avoid
	// throwing errors on empty form
	if (!hasEmptyRequired()) {
		if (validator.form()) {
			$continue.prop('disabled', false);
		}
	} else if (isNIChecked) {
		$continue.prop('disabled', false);
	} else {
		$continue.prop('disabled', true);
	}
}

/**
 * Address lookup input checks
 */
function addressFindValidationInit () {
	$.validator.addMethod('addressFinder', function (value, el) {
		return $(el).hasClass('completed');
	}, Resources.MISSING_ADDRESSFIND);

	$addressFinder.on('focusout', validateAddressFind);
	$addressFinder.addClass('addressFinder');
}

function validateAddressFind () {
	var isAddressFieldsVisible = $form.find('.full-address').hasClass('active');
	var visibleInputsAfterAddressFind = $addressFinder.parents('.form-row').nextAll().find('input, textarea').filter(':visible');
	var wrapperBeforeAddressFind = $addressFinder.parents('.fieldset-wrapper').prevAll();
	var visibleInputsBeforeAddressFind = $addressFinder.parents('.form-row').prevAll().find('input').filter(':visible');
	visibleInputsBeforeAddressFind = visibleInputsBeforeAddressFind.add(wrapperBeforeAddressFind.find('.form-row input').filter(':visible'));
	var finderInputValue = $addressFinder.val();
	var addressFields = $form.find('.full-address').find('input.required');
	var addressFieldsValid = true;
	var inFocus = $addressFinder.is(':focus');
	var addressSuggestionsVisible = $('div.pcaautocomplete.pcatext:visible').length;
	var isCheckRequired = !inFocus && finderInputValue && !addressSuggestionsVisible;
	if (addressSuggestionsVisible) {
		$('div.pcaautocomplete.pcatext').css('max-width', '80%');
	}

	visibleInputsAfterAddressFind.each(function () {
		var $currentInputValue = $(this).attr('type') === 'checkbox' ? $(this).prop('checked') : $(this).val();
		if ($currentInputValue && !$(this).hasClass('init-precheck')) {
			isCheckRequired = true;
		}
	});

	visibleInputsBeforeAddressFind.each(function () {
		var $currentInputValue = $(this).attr('type') === 'checkbox' ? $(this).prop('checked') : $(this).val();
		if (finderInputValue && !$currentInputValue) {
			$form.validate().element($(this));
			// GTM Linchpin analytics
			if (SitePreferences.GTM_ENABLED) {
				linchpin.pushErrorFieldWithDelay($(this));
			}
		}
	});

	addressFields.each(function () {
		if (!$(this).val()) {
			addressFieldsValid = false;
		}
	});

	if (!isCheckRequired || addressFieldsValid || isAddressFieldsVisible) {
		$addressFinder.addClass('completed');
	} else {
		$addressFinder.removeClass('completed');
	}

	if ($addressFinder.valid()) {
		$addressFinder.change();
	}
	// GTM Linchpin analytics
	if (SitePreferences.GTM_ENABLED) {
		linchpin.pushErrorFieldWithDelay($addressFinder);
	}
	linchpin.pushFormFieldsErrorList();
}

function passwordValidationInit () {
	var $passwordEl = $form.find("[id$='password']");
	if ($passwordEl.length) {
		$passwordEl.rules("add", {
			strongPassword: true,
			messages: {
				strongPassword: Resources.PASSWORD_NOTSTRONG
			}
		});
	}
}

var validateEl = function (e) {
	// if form hasn't been yet inited, don't validate elements
	var currentTime = new Date();
	var formInitTime = new Date($form.attr('data-init-time'));
	if (currentTime < formInitTime) {
		return;
	}

	if ($(this).val() === '') {
		$continue.prop('disabled', true);
		if (!$(this).is("select")) {
			validator.element(this);
		}
		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED && e.type === 'focusout') {
			linchpin.pushSingleErrorObject($(this));
		}
	} else {
		// enable continue button on last required field that is valid
		// only validate single field
		if (validator.element(this) && !hasEmptyRequired()) {
			$continue.prop('disabled', false);
		} else if (this.id && this.id.indexOf('ni_delivery_true') !== -1) {
			$continue.prop('disabled', false);
		} else {
			$continue.prop('disabled', true);
			// GTM Linchpin analytics
			if (SitePreferences.GTM_ENABLED && e.type === 'focusout') {
				linchpin.pushSingleErrorObject($(this));
			}
		}
	}
	if (e.type === 'keyup') {
		$(this).removeClass('error').closest('.form-row').find('.error-msg').css('display', 'none');
	}
};

var replaceInvalidCharsInit = function ($form) {
	var $validateFieldsList = $form.find('input[type!="password"], textarea');
	$validateFieldsList.on('keyup input paste', function () {
		this.value = util.replaceInvalidChars($(this).val());
	}).on('change', function () {
		this.value = $(this).val().trim();
	});
};

function validateAutofilledForm () {
	var emptyFieldsNumber = 0,
		filledFieldNumber = 0;

	if ($addressFinder.length) {
		validateAddressFind();
	}

	for (var i = 0; i < $requiredInputs.length; i++) {
		var $currentField = $requiredInputs.eq(i);
		if ($currentField.val() === '') {
			emptyFieldsNumber++;
		} else {
			filledFieldNumber++;
		}
	}

	if (emptyFieldsNumber && filledFieldNumber) {
		$form.trigger('validateautofill');
	}

	if (emptyFieldsNumber) {
		setTimeout(validateAutofilledForm, 500);
		return;
	}
	$form.trigger('validate');
}

function getAllEmptyFields() {
	// Get all empty fields
	$emptyInputs = $form.find(':input[class*="input"]:visible').not('[id$="_addressFind"]').map(function () {
		var inputValue = $(this).attr('type') === 'checkbox' ? $(this).prop('checked') : $(this).val();
		if (!inputValue) {
			return this;
		}
		return null;
	});

}

var invalidateEmptyFieldsBeforeFilled = function () {
	if (!hasEmptyRequired()) {
		return;
	}

	getAllEmptyFields();

	var emptyFieldsNumber = 0,
		$emptyField;
	for (var i = 0; i < $emptyInputs.length; i++) {
		var $currentField = $emptyInputs.eq(i);
		var currentFieldValue = $currentField.attr('type') === 'checkbox' ? $currentField.prop('checked') : $currentField.val();

		if ($currentField.is(':not(:visible)')) {
			continue;
		}

		// skip optional fields excluding 'address finder' input
		if (!$currentField.hasClass('required') && !$currentField.hasClass('addressFinder')) {
			continue;
		}

		if (isEmptyFieldBeforeFilled(currentFieldValue, i)) {
			$form.validate().element($currentField);
			// GTM Linchpin analytics
			if (SitePreferences.GTM_ENABLED) {
				linchpin.pushErrorFieldWithDelay($currentField);
			}
		}

		if (!currentFieldValue) {
			emptyFieldsNumber++;
			$emptyField = $currentField;
		}
	}

	// Include address finder input if 'enter manualy' mode OFF
	if (!$form.find('.enter-manually.active').length && $form.find('.addressFinder').length) {
		emptyFieldsNumber++;
	}

	// Check if one empty field missing between filled
	var isNotLastEmpty = $requiredInputs.index($emptyField) + 1 < $requiredInputs.length;
	if (emptyFieldsNumber === 1 && isNotLastEmpty) {
		$form.validate().element($emptyField);
		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.pushErrorFieldWithDelay($emptyField);
		}
	}
	linchpin.pushFormFieldsErrorList();
};

// check if any empty required field exist before filled one
function isEmptyFieldBeforeFilled (fieldValue, index) {
	if (fieldValue) {
		return false;
	}

	for (var i = index + 1; i < $emptyInputs.length; i++) {
		var $nextField = $emptyInputs.eq(i);
		var nextFieldValue = $nextField.attr('type') === 'checkbox' ? $nextField.prop('checked') : $nextField.val();

		if (nextFieldValue) {
			return true;
		}
	}
	return false;
}

var initializeAutoFillValidation = function ($formParameter) {
	$form = $form || $formParameter;
	customCallback = customCallback || function () {return false;};
	setTimeout(validateAutofilledForm, 500);

	// Get all empty fields
	getAllEmptyFields();

	$form.on('validateautofill', invalidateEmptyFieldsBeforeFilled);
};

var addCustomMessages = function () {
	$requiredInputs.each(function () {
		var $self = $(this);
		var name = $self.attr('name');
		if (!name) {
			return;
		}
		var elementNameArr = name.split("_");
		var elementNameShorten = elementNameArr[elementNameArr.length - 1].toLowerCase();
		var errorMessage = errorMessages.defaultmessage;
	if (customErrorMessagesFields.indexOf(elementNameShorten) >= 0) {
			errorMessage = errorMessages[elementNameShorten] || errorMessages.missingmessage + ' ' + customErrorMessagesNames[elementNameShorten];
		}
		var config = {
			required: true,
			messages: {
				required: errorMessage
			}
		};

		if (name.indexOf('EORINumberNI') > 0) {
			config.messages.minlength = errorMessage;
		}

		$(this).rules("add", config);
	});
};

var init = function (opts) {
	if (!opts.formSelector || !opts.continueSelector) {
		throw new Error('Missing form and continue action selectors.');
	}

	$form = $(opts.formSelector);
	$continue = $(opts.continueSelector);
	$addressFinder = $form.find("[id$='addressFind']");

	if (opts.customCallback) {
		customCallback = opts.customCallback;
	} else {
		customCallback = function () {return false;};
	}

	if (opts.replaceInvalidInput) {
		replaceInvalidCharsInit($form);
	}
	// custom errorPlacement for NI section, required from  NI documentation
	if (opts.errorPlacementNI) {
		if ($form.data('validator')) {
			$('.shipping-details-ni-eori-number').find(':input').removeClass('error');
			$('.shipping-details-ni-eori-number').find('.error.error-msg').remove();
			$form.removeData('validator');
			$form.removeData('unobtrusiveValidation');
		}
		validator = $form.validate({
			errorPlacement: opts.errorPlacementNI
		});
	} else {
		validator = $form.validate();
	}

	$requiredInputs = $form.find(':input').filter('.required');
	validateForm();

	// start listening
	$requiredInputs.on('change focusout', validateEl);
	// Add specific message for each required field from customErrorMessagesFields
	addCustomMessages();

	// GTM Linchpin analytics
	$form.find(':input[id$="mobilephone"]').on('focusout', function () {
		linchpin.pushSingleErrorObject($(this));
	});
	$form.find('label[for$="zip"]').parent().on('change', function () {
		linchpin.pushSingleErrorObject($(this).find('input[id$="zip"]'));
	});

	if (opts.keyup) {
		$requiredInputs.filter('input, textarea').on('keyup', _.debounce(validateEl, 200));
	}

	passwordValidationInit();
	if (opts.autofillValidate) {
		initializeAutoFillValidation($form);
	}
	if ($addressFinder.length) {
		addressFindValidationInit();
	}

	// store form init time to use it to avoid blocking submit button by the validation triggered by 3d party js.
	var formInitTime = new Date();
	formInitTime.setSeconds(formInitTime.getSeconds() + 2);
	$form.attr('data-init-time', formInitTime);
};

exports.init = init;
exports.validateForm = validateForm;
exports.replaceInvalidCharsInit = replaceInvalidCharsInit;
exports.initializeAutoFillValidation = initializeAutoFillValidation;
